//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    EVENT_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    eventDeleteResult,
} from 'Redux/actions';


function* deleteEvent({ payload }) {
    try {
        let QUERY = `
            mutation deleteEvent ($id: Int!) {
                result: deleteEvent (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(eventDeleteResult(data?.result))
        } else yield put(eventDeleteResult())

    } catch (exc) {
        yield put(eventDeleteResult())
        ExceptionManager(exc, 'Modules/events/views/.components/deleteEvent/redux/saga', 'deleteEvent', true);
    }
}

function* watchEventRequests() {
    yield takeEvery(EVENT_DELETE_REQUEST, deleteEvent);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchEventRequests)
    ]);
}